import '@/common/shared/arktype.config';
import { type } from 'arktype';

export const dateRangeType = type(['Date', 'Date']);

/**
 * DateRange type is an array of length two, where
 * the first element is the start date and
 * the second element is the end date.
 * See: https://v17.primeng.org/calendar#range
 */
export type DateRange = typeof dateRangeType.infer;

/*
export type DateRange = [Date, Date]; // TODO validate if the type is okay or if it should be: [] | [Date] | [Date, Date]
*/
